import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'

import Alert from './Alert'
import scrollToElement from '../../utils/scrollToElement'

// TODO This component needs a refactor — fallback prop is doin me a confuse
function AutoScrollAlert({ alert, fallback, ...props }) {
  const ref = useRef()

  useEffect(() => {
    if (alert) {
      scrollToElement(ref.current)
    }
  }, [alert])

  return (
    <Alert ref={ref} mb={4} {...props}>
      {alert.message || fallback}
    </Alert>
  )
}

AutoScrollAlert.propTypes = {
  alert: PropTypes.shape({
    message: PropTypes.string,
  }).isRequired,
  fallback: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
}

export default AutoScrollAlert
